import React from 'react';

export interface GeneratorInterface {
  selectName(name): void;
}

export const GeneratorContext = React.createContext<GeneratorInterface | null>(null);
